import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef,Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { CustomCalendarEvent } from '../warehouse-calendar/warehouse-calendar.component';
import { WarehouseCalendarService } from '../../service/warehouse-calendar.service';
import { ConfirmationService } from 'primeng/api';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { finalize } from 'rxjs/operators';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';



@Component({
  selector: 'warehouse-calendar-copy',
  templateUrl: './warehouse-calendar-copy.component.html',
  styleUrls: ['./warehouse-calendar-copy.component.scss']
})
export class WarehouseCalendarCopyComponent extends SessionBaseComponent implements OnInit {

  @Input() checkLicenseNoList: any;

  @Input() calendarEvents: CustomCalendarEvent[] = [];

  @Input() clickDate: any;

  @Input() systemCategory: any;

  @Output() warehouseCalendarImported: EventEmitter<any>;


  confirmationService: ConfirmationService;

  facilityOptions: any[];

  copyParams: any;

  copyUser: any;

  updateUser: any;

  form: FormGroup;

  yearLabel!: string;

  submitted: boolean;

  hasCalendarData: boolean = true;

  yearList!: any[];

  isLoading: boolean;



  constructor(
    injector: Injector,
    private warehouseCalendarService: WarehouseCalendarService,
    private dropdownOptionsService: DropdownOptionsService,
    private changeDetector: ChangeDetectorRef,
    private fb: FormBuilder) {
    super(injector);
    this.warehouseCalendarImported = new EventEmitter<any>();
    this.checkLicenseNoList = null;

    this.facilityOptions = [];
    this.copyParams = {
      fromFacility:'',
      toFacilityList:[],
      year:'',
      toCategory: ''
    };
    this.copyUser = '';
    this.updateUser = '';
    this.isLoading = false;
    this.confirmationService = injector.get(ConfirmationService);
    this.form = this.fb.group({
      toFacilityList: [[], Validators.required],
      fromFacility: ['', Validators.required],
      toCategory: [null, Validators.required] // 這裡也要綁定 systemCategory
    });
    this.submitted = false;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getFacilityOptions().subscribe({
      next: (result) => {
        this.facilityOptions = result.map((x: any) => {
          return {
            label: x.optionDesc,
            value: x.optionCode,
          };
        });
      },
    });

    this.translateService.get('WarehouseCalendar.Calendar.Year')
    .subscribe({
      next: result => {

        this.yearLabel = result;

        var thisYear = new Date().getFullYear();
        this.yearList =  [];
        for(var i = thisYear; thisYear + 10 >= i; i++) {
          let yearObject : any = {};
          yearObject.label = i.toString() + this.yearLabel;
          yearObject.value = i.toString();
          this.yearList.push(yearObject);
        }
        this.copyParams.year = new Date().getFullYear().toString();
      }
    });

    this.copyParams.toCategory = this.systemCategory;

  }



  saveBtnClick(event: any): void {
    if (this.form.invalid) {
      this.translateService.get('WarehouseCalendar.Alert.CopyCalendar.CheckRequiredFields')
          .subscribe({
            next: msg => {
              this.toastService.warn(msg);
            }
          });
      return;
    }
    var saveparams = {
      year :  this.copyParams.year,
      fromFacility: this.copyParams.fromFacility,
      toFacilityList: this.copyParams.toFacilityList,
      userId: this.userProfile.userName,
      fromCategory: this.systemCategory,
      toCategory: this.copyParams.toCategory
    };

    // 先驗證資料
    if(!this.validateParams(saveparams.fromCategory,saveparams.toCategory,saveparams.fromFacility,saveparams.toFacilityList)){
      this.toastService.warn( saveparams.fromFacility + this.translateService.instant('WarehouseCalendar.Alert.CopyCalendar.SameCategoryAndSameFacilityError'));
      return;
    }

    var checkParams = {
      year :  this.copyParams.year,
      toFacilityList: this.copyParams.toFacilityList,
      toCategory: this.copyParams.toCategory
    };
    console.log("checkParams = ",checkParams);

     // 先去檢查有沒有資料，有要提醒
    this.warehouseCalendarService.checkCalendarData(checkParams)
    .subscribe({
      next: result => {
        this.hasCalendarData = result;
        console.log("hasCalendarData = ",this.hasCalendarData);

        if(this.hasCalendarData) {
          this.confirmationService.confirm({
            header: this.translateService.instant('WarehouseCalendar.Confirm.Header'),
            message: this.translateService.instant('WarehouseCalendar.Confirm.HasCalendarData'),
            icon: 'pi pi-info-circle',
            accept: () => {
              this.saveData(saveparams);
            },
            reject: () => {
                return;
            }
          });
        } else {
          this.saveData(saveparams);
        }
      },
      error: (err: HttpErrorResponse) => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  saveData(params:any){
    console.log("saveData(params)",params);
    this.isLoading = true;
    this.changeDetector.detectChanges();
    console.log(" saveData this.isLoading = ",this.isLoading);


    this.warehouseCalendarService.copyCalendar(params)
      .pipe(finalize(() => {
        this.isLoading = false;
        this.changeDetector.detectChanges();
        console.log(" complete this.isLoading = ",this.isLoading);
      }))
      .subscribe({next: result => {
        this.toastService.success(this.translateService.instant('WarehouseCalendar.Toast.CopySuccess'));
        },
        error: (error: HttpErrorResponse) => {
          if (error.error.errorMsg) {
            this.toastErrorMessage(error.error.errorMsg);
          } else {
            this.toastErrorMessage(error.error);
          }
        },
      });
  }

  validateParams(fromCategory: any, toCategory: any, fromFacility: any, toFacilityList: any): boolean {
    if((fromCategory === toCategory) && toFacilityList.includes(fromFacility)){
      return false;
    }
    return true;
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'toFacilityList':
        this.copyParams.toFacilityList = data;
        break;
      case 'fromFacility':
        this.copyParams.fromFacility = data;
        break;
    }
  }
}

